import { MAIN_SITE_ROUTES } from "@frontend/roz-sdk-core";
import { UiIcon } from "@frontend/roz-uikit";
import { CalendarIcon, GraduationCapIcon } from "lucide-react";

import type { MenuLink } from "./menu-types";

export const TopLinks: MenuLink[] = [
  {
    text: "Календарь мероприятий",
    icon: <CalendarIcon className="sdkui:size-4 sdkui:text-muted-foreground" />,
    href: MAIN_SITE_ROUTES.events,
    "data-testid": "menu_link_events",
  },
  {
    text: "Все проекты",
    icon: (
      <UiIcon
        className="sdkui:size-4 sdkui:text-muted-foreground"
        name="grid"
      />
    ),
    href: MAIN_SITE_ROUTES.projects,
    "data-testid": "menu_link_projects",
  },
  {
    text: "Наши лекторы",
    icon: (
      <GraduationCapIcon className="sdkui:size-4 sdkui:text-muted-foreground" />
    ),
    href: MAIN_SITE_ROUTES.speakers,
    "data-testid": "menu_link_speakers",
  },
];

export const MiddleLinks: MenuLink[] = [
  {
    text: "Кинотеатр",
    href: MAIN_SITE_ROUTES.cinema,
    "data-testid": "menu_link_cinema",
  },
  {
    text: "Лекции",
    href: MAIN_SITE_ROUTES.library,
    "data-testid": "menu_link_library",
  },
  {
    text: "Статьи",
    href: "https://znanierussia.ru/articles/",
    "data-testid": "menu_link_articles",
  },
  {
    text: "Курсы",
    href: "https://akademiya.znanierussia.ru/",
    "data-testid": "menu_link_courses",
  },
  // TODO: подкасты. Скрыть кнопку. Удалить, если будет сформирована задача на полное вырезание функционала
  // {
  //   text: "Подкасты",
  //   href: MAIN_SITE_ROUTES.podcasts,
  //   "data-testid": "menu_link_podcasts",
  // },
];

export const BottomLinks: MenuLink[] = [
  {
    text: "Об обществе",
    href: MAIN_SITE_ROUTES.about,
    "data-testid": "menu_link_about",
  },
  {
    text: "Руководство",
    href: MAIN_SITE_ROUTES.management,
    "data-testid": "menu_link_management",
  },
  {
    text: "Новости",
    href: MAIN_SITE_ROUTES.news,
    "data-testid": "menu_link_news",
  },
];

export const JoinLinks: MenuLink[] = [
  {
    text: "Вступить в Знание",
    href: "https://znanierussia.ru/profile/applector",
    "data-testid": "menu_link_become_lector",
  },
];
